import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth-service';
import { SessionUtils } from '@core/utils/session-utils';

export const ScanQrGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const tableSessionId = authService.tableSessionId();

  if (SessionUtils.isValidSession(tableSessionId)) {
    router.navigate(['/']);
    return false;
  }

  return true;
};
